export const server = "https://testlms-api.onrender.com";
